import { useEffect, useState } from 'react'
import './PhaseManagement.css'
import { authedGet, authedPost } from '../lib/intranet_tools_service'
import { CloseIcon } from '../lib/CloseIcon'

const reverseDate = (date: string) => {
  return date.split('-').reverse().join('-')
}

type Phase = {
  EmployeeCode: string
  NameAV: string
  START: string
  EndDateProject: string
  NrWeeksWorkedBeforeJuly2019: string
  NrWeeksWorkedCOPRA: string
  NrMissingWeeks: string
  WEEKS: string
  PHASE: string
  UZB: string
  OFFER: string
  WHEN: string
  WHAT: string
  StippStartdate: string
  Plus: string
}

const mapPhaseToSelected = (phase: Phase): Phase => {
  return {
    ...phase,
    UZB: phase.UZB === 'y' ? '1' : '0',
    Plus: phase.Plus === 'y' ? '1' : '0',
    OFFER: phase.OFFER === 'y' ? '1' : '0',
  }
}

export const PhaseManagement = () => {
  const [phases, setPhases] = useState<Phase[]>()
  const [selected, setSelected] = useState<Phase | undefined>()
  const [error, setError] = useState('')

  const loadPhases = async () => {
    const result = await authedGet('phase-management')
    if (!result.ok) {
      const json = await result.json()
      setError('Error updating: ' + json.error)
    } else {
      const json = (await result.json()) as Phase[]
      setError('')
      setPhases(json)
    }
  }

  useEffect(() => {
    loadPhases()
  }, [])

  const onClickRow = (phase: Phase) => {
    setSelected(mapPhaseToSelected(phase))
  }

  const onSave = async (phase: Phase) => {
    const result = await authedPost(
      `phase-management/${phase.EmployeeCode}`,
      JSON.stringify(phase)
    )
    if (!result.ok) {
      const json = await result.json()
      setError('Error updating: ' + json.error)
    } else {
      const json = (await result.json()) as Phase[]
      setPhases(json)
      setError('')
      setSelected(undefined)
    }
  }

  const widths = [80, 170, 100, 100, 80, 80, 80, 80, 100, 80, 80, 100, 450]

  return (
    <>
      {selected && (
        <>
          <div className="pm-modal-background"></div>
          <div className="pm-modal-dialog">
            <div className="pm-modal-title">
              <div className="flex flex-justify-between flex-align-center">
                <div>Edit details</div>
                <div
                  className="pm-close"
                  onClick={() => setSelected(undefined)}
                >
                  <CloseIcon width={22} height={22} />
                </div>
              </div>
            </div>
            <div className="pm-modal-content flex flex-col" style={{ gap: 5 }}>
              <div className="flex">
                <div style={{ width: 150 }}>Candidate code</div>
                <div>{selected.EmployeeCode}</div>
              </div>
              <div className="flex">
                <div style={{ width: 150 }}>Name</div>
                <div>{selected.NameAV}</div>
              </div>
              <div className="flex">
                <div style={{ width: 150 }}>PHASE</div>
                <div>
                  <input
                    style={{ width: 50 }}
                    type="number"
                    value={Number(selected.PHASE)}
                    onChange={(e) =>
                      setSelected({ ...selected, PHASE: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="flex">
                <div style={{ width: 150 }}>AC</div>
                <div>
                  <input
                    type="checkbox"
                    checked={selected.UZB === '1'}
                    onChange={(e) => {
                      setSelected({
                        ...selected,
                        UZB: e.target.checked ? '1' : '0',
                      })
                    }}
                  />
                </div>
              </div>
              <div className="flex">
                <div style={{ width: 150 }}>STIPP</div>
                <div>
                  <input
                    type="date"
                    value={reverseDate(selected.StippStartdate)}
                    onChange={(e) =>
                      setSelected({
                        ...selected,
                        StippStartdate: reverseDate(e.target.value),
                      })
                    }
                  />
                </div>
              </div>
              <div className="flex">
                <div style={{ width: 150 }}>PLUS</div>
                <div>
                  <input
                    type="checkbox"
                    checked={selected.Plus === '1'}
                    onChange={(e) =>
                      setSelected({
                        ...selected,
                        Plus: e.target.checked ? '1' : '0',
                      })
                    }
                  />
                </div>
              </div>
              <div className="flex">
                <div style={{ width: 150 }}>OFFER</div>
                <div>
                  <input
                    type="checkbox"
                    checked={selected.OFFER === '1'}
                    onChange={(e) =>
                      setSelected({
                        ...selected,
                        OFFER: e.target.checked ? '1' : '0',
                      })
                    }
                  />
                </div>
              </div>
              <div className="flex">
                <div style={{ width: 150 }}>WHEN</div>
                <div>
                  <input
                    type="date"
                    value={reverseDate(selected.WHEN)}
                    onChange={(e) =>
                      setSelected({
                        ...selected,
                        WHEN: reverseDate(e.target.value),
                      })
                    }
                  />
                </div>
              </div>
              <div className="flex" style={{ gap: 12 }}>
                <div style={{ width: 150 }}></div>
                <button
                  className="pm-modal-button"
                  onClick={() => onSave(selected)}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="phase-management-container">
        <div className="phase-management-title">Phase Management Report</div>
        {error && <div>{error}</div>}
        <div className="table">
          <div className="flex table-row pm-table-header">
            <div style={{ width: widths[0] }}>Code</div>
            <div style={{ width: widths[1] }}>Name</div>
            <div style={{ width: widths[2] }}>Start</div>
            <div style={{ width: widths[3] }}>End</div>
            <div style={{ width: widths[4] }}>Weeks</div>
            <div style={{ width: widths[5] }}>Missing</div>
            <div style={{ width: widths[6] }}>Phase</div>
            <div style={{ width: widths[7] }}>AC</div>
            <div style={{ width: widths[8] }}>Stipp</div>
            <div style={{ width: widths[9] }}>Plus</div>
            <div style={{ width: widths[10] }}>Offer</div>
            <div style={{ width: widths[11] }}>When</div>
            <div style={{ width: widths[12] }}>What</div>
          </div>
          {phases &&
            phases.map((phase) => (
              <div
                key={phase.EmployeeCode}
                className="flex pm-table-row"
                onClick={() => onClickRow({ ...phase })}
              >
                <div style={{ width: widths[0] }}>{phase.EmployeeCode}</div>
                <div style={{ width: widths[1] }}>{phase.NameAV}</div>
                <div style={{ width: widths[2] }}>{phase.START}</div>
                <div style={{ width: widths[3] }}>{phase.EndDateProject}</div>
                <div style={{ width: widths[4] }}>{phase.WEEKS}</div>
                <div style={{ width: widths[5] }}>{phase.NrMissingWeeks}</div>
                <div style={{ width: widths[6] }}>{phase.PHASE}</div>
                <div style={{ width: widths[7] }}>{phase.UZB}</div>
                <div style={{ width: widths[8] }}>{phase.StippStartdate}</div>
                <div style={{ width: widths[9] }}>{phase.Plus}</div>
                <div style={{ width: widths[10] }}>{phase.OFFER}</div>
                <div style={{ width: widths[11] }}>{phase.WHEN}</div>
                <div style={{ width: widths[12] }}>{phase.WHAT}</div>
              </div>
            ))}
        </div>
      </div>
    </>
  )
}
